import { FC, useEffect, useMemo, useState } from 'react';

import DataTable, { DataTableColumn } from 'components/tables/data-table';
import { Role } from 'types';

// import CustomersTab from './customers-tab';

import { ItiLink as Link } from 'components';
import { useNavigate } from 'react-router-dom';
import { fetchPaginated, fetchUsers } from 'services';
import { downloadCsv } from 'services/download-csv';
import { UserProfile } from 'types/user-profile';
import { FilterOperator } from 'utils';
import './users.scss';

const UsersTab: FC = () => {
  const navigate = useNavigate();

  const [_users, setUsers] = useState<UserProfile[]>([]);
  useEffect(() => {
    fetchUsers().then(setUsers);
  }, []);

  const columns: DataTableColumn[] = useMemo(
    () => [
      {
        field: 'username',
        label: 'USERNAME',
        width: 80,
        renderCell: value => <Link to={`/settings/users/${value}`}>{value}</Link>
      },
      { field: 'email', label: 'EMAIL', width: 80 },
      { field: 'role', label: 'ROLE', width: 80, type: 'role' },
      {
        field: 'customers',
        skipQuickSearch: true,
        filterable: false,
        label: 'ACCOUNT',
        width: 80,
        getValue: (row: UserProfile) => (row.customers?.length > 0 ? row.customers.map(c => c.name) : 'ALL')
      },
      {
        field: 'locations',
        label: 'LOCATION',
        skipQuickSearch: true,
        filterable: false,
        width: 80,
        getValue: (row: UserProfile) => (row.locations?.length > 0 ? row.locations.map(l => l.name) : 'ALL')
      },
      {
        field: 'truckingCompanies',
        label: 'TRUCKING COMPANY',
        skipQuickSearch: true,
        filterable: false,
        width: 80,
        getValue: (row: UserProfile) =>
          row.truckingCompanies?.length > 0 ? row.truckingCompanies.map(tc => tc.name) : 'ALL'
      }
    ],
    []
  );

  return (
    <div id="user-table">
      <div className="flex-fill d-flex justify-content-end g-3">
        <button id="create-user" className="btn-primary" onClick={() => navigate('/settings/users/new')}>
          NEW USER
        </button>
      </div>
      <DataTable
        fetchData={fetchPaginated<UserProfile>('users')}
        fetchCsv={downloadCsv('users')}
        columns={columns}
        initialFilters={{ filters: [{ field: 'role', filterOperator: FilterOperator.NOT_EQUALS, value: Role.NONE }] }}
        initialPage={{ pageSize: 25 }}
        initialColumns={columns.map(c => {
          return { field: c.field, width: c.width };
        })}
        rowClassName={user => (!!user.active ? '' : 'deleted')}
        csvFilename="Users"
      />
    </div>
  );
};

export default UsersTab;
